export default {
  path: '/index',
  name: 'index',
  redirect: {
    name: 'memberCenter'
  },
  component: function component() {
    return import('@/layouts/basic-layout');
  },
  children: [// 配置中心-运维管理-数据字典维护
  {
    path: 'dataDictionaryList',
    name: 'dataDictionaryList',
    meta: {
      title: '数据字典维护',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['dataDictionaryList']
    },
    component: function component() {
      return import('@/pages/configureModule/mochaITOMMenu/dataDictionaryList/dataDictionaryList');
    }
  }, // 配置中心-运维管理-数据字典维护-管理
  {
    path: 'dataDictionaryManage',
    name: 'dataDictionaryManage',
    meta: {
      title: '数据字典管理',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/mochaITOMMenu/dataDictionaryList/dataDictionaryManage');
    }
  }, // 配置中心-配置表管理-机构类型配置
  {
    path: 'orgConfigureList',
    name: 'orgConfigureList',
    meta: {
      title: '机构类型配置',
      isCheckMenu: true,
      belongMenus: ['orgConfigureList']
    },
    component: function component() {
      return import('@/pages/configureModule/configureMenu/orgConfigureList/orgConfigureList');
    }
  }, // 配置中心-参数配置-公共参数
  {
    path: 'commonParam',
    name: 'commonParam',
    meta: {
      title: '公共参数',
      isCheckMenu: true,
      belongMenus: ['commonParam']
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commonParam/commonParam');
    }
  }, // 配置中心-参数配置-公共参数
  {
    path: 'planManageParam',
    name: 'planManageParam',
    meta: {
      title: '计划管理参数',
      isCheckMenu: true,
      belongMenus: ['planManageParam']
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/planManageParam/planManageParam');
    }
  }, // 配置中心-参数配置-计划管理参数Y-计划应用模式设置-新增设置
  {
    path: 'addPlanApplicationSetting',
    name: 'addPlanApplicationSetting',
    meta: {
      title: '计划应用模式设置-新增设置',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/planManageParam/planApplicationModelConfig/addPlanApplicationSetting');
    }
  }, // 配置中心-配置表-数量/计量单位配置表
  {
    path: 'numCountList',
    name: 'numCountList',
    meta: {
      title: '数量/计量单位配置表',
      cache: true
    },
    component: function component() {
      return import('@/pages/configureModule/configureMenu/numCountList/numCountList');
    }
  }, // 配置中心-配置表-需求提报汇总与计划单位映射表
  {
    path: 'demanSubmitAndSummary',
    name: 'demanSubmitAndSummary',
    meta: {
      title: '需求提报汇总与计划单位映射表',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['demanSubmitAndSummary']
    },
    component: function component() {
      return import('@/pages/configureModule/configureMenu/demanSubmitAndSummary/demanSubmitAndSummary');
    }
  }, // 配置中心-配置表-需求提报汇总与计划单位映射表-新增
  {
    path: 'addDemanSubmitAndSummary',
    name: 'addDemanSubmitAndSummary',
    meta: {
      title: '需求提报汇总与计划单位映射表-新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/configureMenu/demanSubmitAndSummary/addDemanSubmitAndSummary');
    }
  }, // 配置中心-配置表-采购单位与运营机构映射表
  {
    path: 'purchaseAndOperateOrg',
    name: 'purchaseAndOperateOrg',
    meta: {
      title: '采购单位与运营机构映射表',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['purchaseAndOperateOrg']
    },
    component: function component() {
      return import('@/pages/configureModule/configureMenu/purchaseAndOperateOrg/purchaseAndOperateOrg');
    }
  }, // 配置中心-配置表-采购单位与运营机构映射表-新增
  {
    path: 'addPurchaseAndOperateOrg',
    name: 'addPurchaseAndOperateOrg',
    meta: {
      title: '采购单位与运营机构映射表-新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/configureMenu/purchaseAndOperateOrg/addPurchaseAndOperateOrg');
    }
  }, // 配置中心-参数设置-合同管理参数
  {
    path: 'contractManageParam',
    name: 'contractManageParam',
    meta: {
      title: '合同管理参数',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['contractManageParam']
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/contractManageParam/contractManageParam.vue');
    }
  }, // 配置中心-参数设置-订单管理参数
  {
    path: 'orderManageParam',
    name: 'orderManageParam',
    meta: {
      title: '订单管理参数',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['orderManageParam']
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/orderManageParam/orderManageParam.vue');
    }
  }, // 配置中心-参数设置-订单管理参数
  {
    path: 'orderManageParam',
    name: 'orderManageParam',
    meta: {
      title: '订单管理参数',
      cache: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/orderManageParam/orderManageParam.vue');
    }
  }, // 配置中心-参数设置-订单时限类配置修改
  {
    path: 'orderTimeLimitSettingEdt',
    name: 'orderTimeLimitSettingEdt',
    meta: {
      title: '订单时限类配置修改',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/orderManageParam/orderTimeLimitSetting/orderTimeLimitSettingEdt.vue');
    }
  }, // 配置中心-参数设置-订单时限类配置添加例外
  {
    path: 'addException',
    name: 'addException',
    meta: {
      title: '添加例外',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/orderManageParam/orderTimeLimitSetting/addException.vue');
    }
  }, // 配置中心-参数设置-订单按钮类配置-查看供应商
  {
    path: 'supplierDetail',
    name: 'supplierDetail',
    meta: {
      title: '查看供应商',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/orderManageParam/orderButtonSetting/supplierDetail.vue');
    }
  }, // 配置中心-参数设置-差异化验收配置-修改差异化验收
  {
    path: 'orderDifferentConfigurationEidt',
    name: 'orderDifferentConfigurationEidt',
    meta: {
      title: '修改差异化验收',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/orderManageParam/orderDifferentConfiguration/orderDifferentConfigurationEidt.vue');
    }
  }, // 配置中心-参数设置-差异化验收配置-差异化详情
  {
    path: 'orderDifferentConfigurationDetail',
    name: 'orderDifferentConfigurationDetail',
    meta: {
      title: '差异化详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/orderManageParam/orderDifferentConfiguration/orderDifferentConfigurationDetail.vue');
    }
  }, // 配置中心-参数配置-公共参数
  {
    path: 'commodityManageParam',
    name: 'commodityManageParam',
    meta: {
      title: '商品管理参数',
      cache: false,
      isCheckMenu: true,
      belongMenus: ['commodityManageParam']
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/commodityManageParam');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-修改商品编码规则
  {
    path: 'editSkuCodeSetting',
    name: 'editSkuCodeSetting',
    meta: {
      title: '修改商品编码规则',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/editSkuCodeSetting');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-修改电商商品完整性校验规则
  {
    path: 'editEcSkuValidSetting',
    name: 'editEcSkuValidSetting',
    meta: {
      title: '修改电商商品完整性校验规则',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/editEcSkuValidSetting');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-修改电商商品自动上架设置
  {
    path: 'editEcSkuAutoOnShelfSetting',
    name: 'editEcSkuAutoOnShelfSetting',
    meta: {
      title: '修改电商商品自动上架设置',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/editEcSkuAutoOnShelfSetting');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-修改商品强制下架功能启用规则
  {
    path: 'editEcSkuForcedOffShelfSetting',
    name: 'editEcSkuForcedOffShelfSetting',
    meta: {
      title: '修改商品强制下架功能启用规则',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/editEcSkuForcedOffShelfSetting');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-修改电商商品价格预警&自动下架规则
  {
    path: 'editEcSkuAutoOffShelfSetting',
    name: 'editEcSkuAutoOffShelfSetting',
    meta: {
      title: '修改电商商品价格预警&自动下架规则',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/editEcSkuAutoOffShelfSetting');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-修改前台类目编码规则
  {
    path: 'editReceptionCataCodeSetting',
    name: 'editReceptionCataCodeSetting',
    meta: {
      title: '修改前台类目编码规则',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/editReceptionCataCodeSetting');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-新增频道推荐搜索词展示规则
  {
    path: 'formChannelKeywordShowSetting',
    name: 'formChannelKeywordShowSetting',
    meta: {
      title: '修改前台类目编码规则',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/formChannelKeywordShowSetting');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-修改商品池编号规则
  {
    path: 'editPoolCodeSetting',
    name: 'editPoolCodeSetting',
    meta: {
      title: '修改商品池编号规则',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/editPoolCodeSetting');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-修改商品属性编码规则
  {
    path: 'editSkuAttrCodeSetting',
    name: 'editSkuAttrCodeSetting',
    meta: {
      title: '修改商品属性编码规则',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/editSkuAttrCodeSetting');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-修改商品属性编码规则
  {
    path: 'editSkuAttrValueCodeSetting',
    name: 'editSkuAttrValueCodeSetting',
    meta: {
      title: '修改商品属性编码规则',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/editSkuAttrValueCodeSetting');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-修改商品属性组编码
  {
    path: 'editSkuAttrGroupCodeSetting',
    name: 'editSkuAttrGroupCodeSetting',
    meta: {
      title: '修改商品属性组编码',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/editSkuAttrGroupCodeSetting');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-修改标签编号
  {
    path: 'editSkuLabelCodeSetting',
    name: 'editSkuLabelCodeSetting',
    meta: {
      title: '修改标签编号',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/editSkuLabelCodeSetting');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-修改物料分类编码
  {
    path: 'editSkuMaterialTypeSetting',
    name: 'editSkuMaterialTypeSetting',
    meta: {
      title: '修改物料分类编码',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/editSkuMaterialTypeSetting');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-修改无协议商品创建是否依据入驻服务合同规则 【已抛弃】
  {
    path: 'formUnargSkuIsContractSetting',
    name: 'formUnargSkuIsContractSetting',
    meta: {
      title: '修改无协议商品创建是否依据入驻服务合同规则',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/formUnargSkuIsContractSetting');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-修改电商商品默认加价系数规则
  {
    path: 'formSkuPriceIncreaseSetting',
    name: 'formSkuPriceIncreaseSetting',
    meta: {
      title: '修改电商商品默认加价系数规则',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/formSkuPriceIncreaseSetting');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-添加电商商品默认加价系数规则
  {
    path: 'formSkuPriceIncreaseAdd',
    name: 'formSkuPriceIncreaseAdd',
    meta: {
      title: '添加电商商品默认加价系数规则',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/formSkuPriceIncreaseAdd');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-修改无协议商品创建是否依据入驻服务合同规则
  {
    path: 'formUnargSkuIsSignApplySetting',
    name: 'formUnargSkuIsSignApplySetting',
    meta: {
      title: '修改无协议商品创建是否依据入驻服务合同规则',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/formUnargSkuIsSignApplySetting');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-修改计量单位小数位数限制规则
  {
    path: 'editUnitDecimalLimitSetting',
    name: 'editUnitDecimalLimitSetting',
    meta: {
      title: '修改计量单位小数位数限制规则',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/editUnitDecimalLimitSetting');
    }
  }, // 配置中心-参数配置-公共参数-商品管理参数-修改商品搜索结果展示综合排序规则
  {
    path: 'formSkuSearchShowSetting',
    name: 'formSkuSearchShowSetting',
    meta: {
      title: '修改商品搜索结果展示综合排序规则',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commodityManageParam/formSkuSearchShowSetting');
    }
  }, // 配置中心-参数设置-协议管理参数-基本规则设置
  {
    path: 'agreementManageParam',
    name: 'agreementManageParam',
    meta: {
      title: '协议管理参数',
      cache: false,
      isCheckMenu: true,
      belongMenus: ['agreementManageParam']
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/agreementManageParam/agreementManageParam');
    }
  }, // 配置中心-数据权限管理-岗位管理
  {
    path: 'postList',
    name: 'postList',
    meta: {
      title: '岗位管理',
      isCheckMenu: true,
      belongMenus: ['postList']
    },
    component: function component() {
      return import('@/pages/configureModule/dataAuthMenu/postList/postList');
    }
  }, // 配置中心-数据权限管理-岗位管理-数据权限设置
  {
    path: 'postPermissionSet',
    name: 'postPermissionSet',
    meta: {
      title: '数据权限设置'
    },
    component: function component() {
      return import('@/pages/configureModule/dataAuthMenu/postList/postPermissionSet');
    }
  }, // 配置中心-数据权限管理-岗位管理-岗位详情
  {
    path: 'postDetail',
    name: 'postDetail',
    meta: {
      title: '岗位详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/dataAuthMenu/postList/postDetail');
    }
  }, // 配置中心-资源管理-菜单管理
  {
    path: 'menuList',
    name: 'menuList',
    meta: {
      title: '菜单管理',
      isCheckMenu: true,
      belongMenus: ['menuList']
    },
    component: function component() {
      return import('@/pages/configureModule/resourceMenu/menuList/menuList');
    }
  }, // 配置中心-资源管理-子页面管理
  {
    path: 'subPageList',
    name: 'subPageList',
    meta: {
      title: '子页面管理',
      isCheckMenu: true,
      belongMenus: ['menuList']
    },
    component: function component() {
      return import('@/pages/configureModule/resourceMenu/subPageList/subPageList');
    }
  }, // 配置中心-数据权限管理-数据资源类型
  {
    path: 'dataResourceTypeList',
    name: 'dataResourceTypeList',
    meta: {
      title: '数据资源类型',
      isCheckMenu: true,
      belongMenus: ['dataResourceTypeList']
    },
    component: function component() {
      return import('@/pages/configureModule/dataAuthMenu/dataResourceTypeList/dataResourceTypeList');
    }
  }, // 配置中心-数据权限管理-数据资源类型详情
  {
    path: 'dataResourceDetail',
    name: 'dataResourceDetail',
    meta: {
      title: '数据资源类型详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/dataAuthMenu/dataResourceTypeList/dataResourceDetail');
    }
  }, // 配置中心-数据权限管理-数据权限类型配置
  {
    path: 'dataAuthTypeList',
    name: 'dataAuthTypeList',
    meta: {
      title: '数据权限类型配置',
      isCheckMenu: true,
      belongMenus: ['dataAuthTypeList']
    },
    component: function component() {
      return import('@/pages/configureModule/dataAuthMenu/dataAuthTypeList/dataAuthTypeList');
    }
  }, // 配置中心-数据权限管理-数据权限类型新增
  {
    path: 'dataAuthTypeAdd',
    name: 'dataAuthTypeAdd',
    meta: {
      title: '数据权限类型新增',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/dataAuthMenu/dataAuthTypeList/dataAuthTypeAdd');
    }
  }, // 配置中心-搜索引擎配置
  {
    path: 'queryToolManage',
    name: 'queryToolManage',
    meta: {
      title: '查询分析',
      cache: true
    },
    component: function component() {
      return import('@/pages/configureModule/searchEngineMenu/queryToolManage/queryToolManage');
    }
  }, // 配置中心-数据权限管理-数据权限类型配置-数据权限详情
  {
    path: 'dataAuthTypeDetail',
    name: 'dataAuthTypeDetail',
    meta: {
      title: '数据权限详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/dataAuthMenu/dataAuthTypeList/dataAuthTypeDetail');
    }
  }, // 配置中心-下载中心-文件模板
  {
    path: 'fileTemplateList',
    name: 'fileTemplateList',
    meta: {
      title: '文件模板',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['fileTemplateList']
    },
    component: function component() {
      return import('@/pages/configureModule/downloadCenterMenu/fileTemplateList/fileTemplateList');
    }
  }, // 配置中心-下载中心-文件模板-新增
  {
    path: 'fileTemplateAdd',
    name: 'fileTemplateAdd',
    meta: {
      title: '文件模板',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/downloadCenterMenu/components/fileTemplateAdd');
    }
  }, // 配置中心-下载中心-文件模板详情
  {
    path: 'fileTemplateDetail',
    name: 'fileTemplateDetail',
    meta: {
      title: '文件模板详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/downloadCenterMenu/fileTemplateList/fileTemplateDetail');
    }
  }, // 配置中心-下载中心-服务管理
  {
    path: 'serviceManageList',
    name: 'serviceManageList',
    meta: {
      title: '服务管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['serviceManageList']
    },
    component: function component() {
      return import('@/pages/configureModule/downloadCenterMenu/serviceManageList/serviceManageList');
    }
  }, // 配置中心-下载中心-服务管理-新增
  {
    path: 'serviceManageAdd',
    name: 'serviceManageAdd',
    meta: {
      title: '服务管理',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/downloadCenterMenu/components/serviceManageAdd');
    }
  }, // 配置中心-下载中心-服务管理详情
  {
    path: 'serviceManageDetail',
    name: 'serviceManageDetail',
    meta: {
      title: '服务管理详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/downloadCenterMenu/serviceManageList/serviceManageDetail');
    }
  }, // 配置中心-下载中心-功能管理
  {
    path: 'functionManageList',
    name: 'functionManageList',
    meta: {
      title: '功能管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['functionManageList']
    },
    component: function component() {
      return import('@/pages/configureModule/downloadCenterMenu/functionManageList/functionManageList');
    }
  }, // 配置中心-下载中心-功能管理-新增
  {
    path: 'functionManageAdd',
    name: 'functionManageAdd',
    meta: {
      title: '功能管理',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/downloadCenterMenu/components/functionManageAdd');
    }
  }, // 配置中心-下载中心-功能管理详情
  {
    path: 'functionManageDetail',
    name: 'functionManageDetail',
    meta: {
      title: '功能管理详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/downloadCenterMenu/functionManageList/functionManageDetail');
    }
  }, // 配置中心-参数设置-公共参数-平台模块启用设置-修改平台模块启用设置规则
  {
    path: 'modifyPlatModuleEnable',
    name: 'modifyPlatModuleEnable',
    meta: {
      title: '修改平台模块启用设置规则',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/commonParam/components/platformModuleEnable/modifyPlatModuleEnable');
    }
  }, // 配置中心-参数设置-支付结算参数
  {
    path: 'paySettlementParam',
    name: 'paySettlementParam',
    meta: {
      title: '支付结算参数列表',
      hidden: false,
      isCheckMenu: true,
      belongMenus: ['paySettlementParam']
    },
    component: function component() {
      return import('@/pages/configureModule/paramSettingMenu/paySettlementParam/paySettlementParam');
    }
  }, // 配置中心-配置表-品类与资质映射表
  {
    path: 'mappingList',
    name: 'mappingList',
    meta: {
      title: '品类与资质映射表',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['mappingList']
    },
    component: function component() {
      return import('@/pages/configureModule/configureListMenu/mappingList/mappingList');
    }
  }, // 配置中心-通知中心-失信行为通知模板
  {
    path: 'supDishonestyTemplateList',
    name: 'supDishonestyTemplateList',
    meta: {
      title: '失信行为通知模板',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supDishonestyTemplateList']
    },
    component: function component() {
      return import('@/pages/configureModule/noticeCenterMenu/supDishonestyTemplateList/supDishonestyTemplateList');
    }
  }, // 配置中心-通知中心-整改通知模板
  {
    path: 'supRectificationTemplateList',
    name: 'supRectificationTemplateList',
    meta: {
      title: '整改通知模板',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supRectificationTemplateList']
    },
    component: function component() {
      return import('@/pages/configureModule/noticeCenterMenu/supRectificationTemplateList/supRectificationTemplateList');
    }
  }, // 配置中心-运维管理-返回信息管理
  {
    path: 'returnDataList',
    name: 'returnDataList',
    meta: {
      title: '返回信息管理',
      isCheckMenu: true,
      belongMenus: ['returnDataList']
    },
    component: function component() {
      return import('@/pages/configureModule/mochaITOMMenu/returnDataList/returnDataList');
    }
  }, // 配置中心-配置表管理-平台服务费缴纳周期配置
  {
    path: 'platServiceFeePayList',
    name: 'platServiceFeePayList',
    meta: {
      title: '平台服务费缴纳周期配置',
      isCheckMenu: true,
      belongMenus: ['platServiceFeePayList']
    },
    component: function component() {
      return import('@/pages/configureModule/configureMenu/platServiceFeePayList/platServiceFeePayList');
    }
  }, // 配置中心-模板管理-导入模板管理
  {
    path: 'importTemplateList',
    name: 'importTemplateList',
    meta: {
      title: '导入模板管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['importTemplateList']
    },
    component: function component() {
      return import('@/pages/configureModule/templateManageMenu/importTemplateList/importTemplateList');
    }
  }, // 配置中心-模板管理-导入模板管理-新增/修改
  {
    path: 'importTemplateAdd',
    name: 'importTemplateAdd',
    meta: {
      title: '导入模板管理',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/templateManageMenu/importTemplateList/importTemplateAdd');
    }
  }, // 配置中心-模板管理-导入模板管理-详情
  {
    path: 'importTemplateDetail',
    name: 'importTemplateDetail',
    meta: {
      title: '导入模板管理详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/templateManageMenu/importTemplateList/importTemplateDetail');
    }
  }, // 配置中心-模板管理-评价模板管理
  {
    path: 'evaluationTemplateList',
    name: 'evaluationTemplateList',
    meta: {
      title: '评价模板管理',
      isCheckMenu: true,
      belongMenus: ['evaluationTemplateList']
    },
    component: function component() {
      return import('@/pages/configureModule/templateManageMenu/evaluationTemplateList/evaluationTemplateList');
    }
  }, // 配置中心-模板管理-评价模板管理-详情
  {
    path: 'evaluationTemplateDetail',
    name: 'evaluationTemplateDetail',
    meta: {
      title: '评价模板管理详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/templateManageMenu/evaluationTemplateList/evaluationTemplateDetail');
    }
  }, // 配置中心-模板管理-评价模板管理-新增
  {
    path: 'evaluationTemplateAdd',
    name: 'evaluationTemplateAdd',
    meta: {
      title: '评价模板管理',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/templateManageMenu/evaluationTemplateList/evaluationTemplateAdd');
    }
  }, // 配置中心-模板管理-打印模板管理
  {
    path: 'printTemplateList',
    name: 'printTemplateList',
    meta: {
      title: '打印模板管理',
      // hidden: true,
      isCheckMenu: true,
      belongMenus: ['printTemplateList']
    },
    component: function component() {
      return import('@/pages/configureModule/templateManageMenu/printTemplateList/printTemplateList');
    }
  }, // 配置中心-模板管理-供应商模板管理
  {
    path: 'supplierTemplateList',
    name: 'supplierTemplateList',
    meta: {
      title: '供应商模板管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supplierTemplateList'] // hidden: true

    },
    component: function component() {
      return import('@/pages/configureModule/templateManageMenu/supplierTemplate/supplierTemplateList');
    }
  }, // 配置中心-模板管理-供应商模板管理
  {
    path: 'supplierTemplateAdd',
    name: 'supplierTemplateAdd',
    meta: {
      title: '准入模板',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/templateManageMenu/supplierTemplate/components/supplierTemplateAdd');
    }
  }, // 1menu配置中心-YD / 2menu模板管理  / 3menu供应商模板管理 / 定级申请模板-企业概况
  {
    path: 'companyTemplateAdd',
    name: 'companyTemplateAdd',
    meta: {
      title: '定级申请模板-企业概况',
      hidden: true
    },
    component: function component() {
      return import('@/pages/configureModule/templateManageMenu/supplierTemplate/components/companyTemplateAdd');
    }
  }, // 消息中心
  {
    path: 'newMessageList',
    name: 'newMessageList',
    meta: {
      title: '我的消息'
    },
    component: function component() {
      return import('@/pages/shopMall/messageList/messageList');
    }
  }, // 消息中心
  {
    path: 'newMessageDetail',
    name: 'newMessageDetail',
    meta: {
      title: '我的消息详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/shopMall/messageList/messageDetail');
    }
  }]
};